(async function setupIPBlocking() {
  const ips = `80.107.16.229`.split("<br />").map(row => row.trim()).filter(Boolean)
  
  const response = await fetch('https://api.ipify.org?format=json');
  const { ip } = await response.json();
  
  if (ips.includes(ip)) {
    const checkoutBtn = document.querySelector("#CheckOut")
    checkoutBtn.remove()
  }
  
})()
